import { createAction } from '@reduxjs/toolkit';
import { IActivity } from '../../../../dto';
import { ACT_SET, TYPE_LIST, MN_ACTIVITIES } from '../../../../common';

export const setActivities = createAction<IActivity[]>(
  `${MN_ACTIVITIES}/${TYPE_LIST}/${ACT_SET}`,
);
